import React, { memo } from 'react';
import Glow from './Glow';

const FocusRingIcon = ({ id, size }) => (
  <a-image
    id={id}
    visible={false}
    src={`#hotspot__outline`}
    material="transparent: true; depthWrite: false;"
    width={size}
    height={size}
    scale="1.3 1.3 1.3"
    opacity={1}
    position="0 0 -0.01"
  />
);

const AframeIcon = ({
  src,
  id,
  darkMode,
  forwardRef,
  iconSize = {},
  hideGlow = false,
  iconId,
  focusId,
  ...rest
}) => {
  return (
    <a-image
      ref={forwardRef}
      class="clickable"
      material="transparent: true; depthWrite: false;"
      src={src}
      id={id}
      width={iconSize.size}
      height={iconSize.size}
      scale="1 1 1"
      opacity="0.9"
      position="0 0 0"
      {...rest}
    >
      <FocusRingIcon id={focusId} size={iconSize.size} {...rest} />
      {!hideGlow && (
        <Glow
          darkMode={darkMode}
          size={iconSize.size}
          data-testid={`hotspot-glow_${iconId}`}
        />
      )}
    </a-image>
  );
};

export default memo(AframeIcon);
